// extracted by mini-css-extract-plugin
export default {"contentCol":"ContactScreen_contentCol__mIXuL","formCol":"ContactScreen_formCol__Rn8wF","info":"ContactScreen_info__qYglb"};